import React, { useEffect, useState, useCallback } from "react";
import { blockchainService } from "../../../../../services/blockchainService";
import { subTopicos } from "../../../styles";

import { MergeArquivo } from "../../Actions/Merge/MergeArquivo";
import { BuscaMerge } from "../../Actions/Merge/BuscaMerge";
import { CancelarMerge } from "../../Actions/Merge/CancelMerge";
import { DownloadMerge } from "../../Actions/Merge/DownloadMerge";
import MintButton from "../../Actions/Merge/MintButton";
import LogsMerge from "../../Actions/Merge/LogsMerge/LogsMerge";

/* Styles */
import {
  DocumentsContainer,
  DocumentItem,
  DocumentInfo,
  DocumentActions,
} from "./TopicDocuments.styles";


export const TopicMergeSection = ({
  projectId,
  modeloId,
  topicData,
  contractAddress,
  headers,
  setdocMap,
}) => {
  const [mergedDocs, setMergedDocs] = useState([]);
  const [reloadTrigger, setReloadTrigger] = useState(false);

  const topicId = topicData?.titulo?.id;
  const questoes = topicData?.questoes || [];

  const fetchMerges = useCallback(async () => {


    if (!projectId || !topicId || !modeloId) {
      console.warn("⛔ Não chamou API porque algum ID está vazio");
      return;
    }

    try {
      const response =
        await blockchainService.getMergedDocumentsByTopic(
          projectId,
          topicId,
          modeloId,
          headers
        );

      setMergedDocs(response || []);
    } catch (err) {
      console.error("❌ Erro ao buscar merges:", err);
      setMergedDocs([]);
    }
  }, [projectId, topicId, modeloId, headers]);

  useEffect(() => {
    fetchMerges();
  }, [fetchMerges, reloadTrigger]);



  // 🔒 regra de exibição (contrato desativado temporariamente)
  if (!contractAddress?.trim() || questoes.length <= 1) {
    return null;
  }



  const mergesDoTopico = mergedDocs.filter(
    (merge) =>
      String(merge.project) === String(projectId) &&
      String(merge.topic_document) === String(topicId)
  );


  const existeMerge = mergesDoTopico.length > 0;

  const mergesAtivos = mergesDoTopico.filter(
    (merge) => !merge.is_cancelado
  );

  const hasMinted = mergesDoTopico.some(
    (merge) => merge.is_minted
  );

  const existeMergeAtivo = mergesAtivos.length > 0;


  const recarregaMerge = () => {
    setReloadTrigger((prev) => !prev);
  };

  return (
    <DocumentsContainer>
      <DocumentItem>
        <DocumentInfo>
          <strong style={subTopicos.strongText}>
            {`MERGE: ${topicData?.titulo?.label || `Etapa ${topicId}`}`}
          </strong>

          <BuscaMerge mergedDocs={mergesDoTopico} />
        </DocumentInfo>

        <DocumentActions>
          <MergeArquivo
            projectId={projectId}
            modeloDocumentId={modeloId}
            modeloTopicId={topicId}
            recarregaMerge={recarregaMerge}
          />

          {existeMerge && (
            <>
              <LogsMerge
                projectId={projectId}
                modeloDocumentId={modeloId}
                modeloTopicId={topicId}
              />

              <CancelarMerge
                projectId={projectId}
                modeloDocumentId={modeloId}
                topicDocumentId={topicId}
                recarregaMerge={recarregaMerge}
                disabled={!existeMergeAtivo || hasMinted}
              />

              <DownloadMerge
                projectId={projectId}
                modeloDocumentId={modeloId}
                modeloTopicId={topicId}
                disabled={!existeMergeAtivo}
              />

              {existeMergeAtivo &&
                mergesAtivos.map((merge) => (
                  <MintButton
                    key={merge.id}
                    merge={merge}
                    headers={headers}
                    project_id={projectId}
                    modelo_GUID={modeloId}
                    setdocMap={setdocMap}
                  />
                ))}
            </>
          )}
        </DocumentActions>
      </DocumentItem>
    </DocumentsContainer>
  );
};